export default ()=>{    
    const popupOpenButtons = document.querySelectorAll('[data-play-teaser]');

    popupOpenButtons.forEach(button =>{
        const popup = document.querySelector('[data-popup="'+ button.dataset.playTeaser + '"]');
        button.addEventListener('click', ()=>{
            popup.classList.add('active');
            document.body.style.overflow = "hidden"
        })
        
        const closePopup = popup.querySelectorAll('[data-teaser-close]');

        closePopup.forEach(close =>{
            close.addEventListener('click', ()=>{
                popup.classList.remove('active');
                document.body.style.overflow = "auto"
            })
        })
    })
}